module.exports = __webpack_public_path__ + "static/media/tatamotors.33bb4a5c.png";